import ApplicationController from './application_controller'

class ExperienceDateValidationController extends ApplicationController {
  connect () {
    this.form = this.element
    // Use capture phase to run before Rails UJS disables the button
    this.form.addEventListener('submit', this.validateDates.bind(this), true)

    // Clear custom validity on date change
    this.form.querySelectorAll('.we-period-selects select').forEach(select => {
      select.addEventListener('change', () => this.clearValidation())
    })
  }

  disconnect () {
    this.form.removeEventListener('submit', this.validateDates.bind(this))
  }

  validateDates (event) {
    const periodContainers = this.form.querySelectorAll('.we-period-selects')
    if (periodContainers.length < 2) return true

    const startContainer = periodContainers[0]
    const endContainer = periodContainers[1]

    // Support both naming conventions: startdate/enddate and start_date/end_date
    const startYearSelect = startContainer.querySelector('select[id*="_startdate_1i"], select[id*="_start_date_1i"]')
    const startMonthSelect = startContainer.querySelector('select[id*="_startdate_2i"], select[id*="_start_date_2i"]')
    const endYearSelect = endContainer.querySelector('select[id*="_enddate_1i"], select[id*="_end_date_1i"]')
    const endMonthSelect = endContainer.querySelector('select[id*="_enddate_2i"], select[id*="_end_date_2i"]')

    if (!startYearSelect || !endYearSelect) return true

    const startYear = parseInt(startYearSelect.value)
    const startMonth = parseInt(startMonthSelect?.value)
    const endYear = parseInt(endYearSelect.value)
    const endMonth = parseInt(endMonthSelect?.value)

    // Clear previous validation
    this.clearValidation()

    // Check if start year is set but month is not
    if (startYear && !isNaN(startYear) && (!startMonth || isNaN(startMonth))) {
      event.preventDefault()
      event.stopImmediatePropagation()
      startMonthSelect.setCustomValidity(I18n.t('errors.messages.blank'))
      startMonthSelect.reportValidity()
      this.resetSubmitButton()
      return false
    }

    // Check if end year is set but month is not
    if (endYear && !isNaN(endYear) && (!endMonth || isNaN(endMonth))) {
      event.preventDefault()
      event.stopImmediatePropagation()
      endMonthSelect.setCustomValidity(I18n.t('errors.messages.blank'))
      endMonthSelect.reportValidity()
      this.resetSubmitButton()
      return false
    }

    // If end date is not set, it's valid (ongoing)
    if (!endYear || isNaN(endYear)) {
      return true
    }

    // If start date is not set but end date is set, it's valid
    if (!startYear || isNaN(startYear)) {
      return true
    }

    const startDate = new Date(startYear, startMonth - 1, 1)
    const endDate = new Date(endYear, endMonth - 1, 1)

    if (startDate > endDate) {
      event.preventDefault()
      event.stopImmediatePropagation()

      const errorMessage = I18n.t('errors.messages.start_date_after_end_date')

      // Use native HTML5 validation API to show browser popup
      endYearSelect.setCustomValidity(errorMessage)
      endYearSelect.reportValidity()

      // Re-enable submit button if it was disabled by Rails UJS
      this.resetSubmitButton()

      return false
    }

    return true
  }

  clearValidation () {
    const periodContainers = this.form.querySelectorAll('.we-period-selects')
    periodContainers.forEach(container => {
      container.querySelectorAll('select').forEach(select => {
        select.setCustomValidity('')
      })
    })
  }

  resetSubmitButton () {
    const submitButton = this.form.querySelector('input[type="submit"], button[type="submit"]')
    if (submitButton) {
      submitButton.disabled = false
      // Restore original text if it was changed by Rails UJS disable_with
      const originalText = submitButton.dataset.enableWith || submitButton.dataset.originalText
      if (originalText) {
        submitButton.value = originalText
        submitButton.textContent = originalText
      } else {
        // Fallback: use the translation for 'save'
        const saveText = I18n.t('save')
        if (submitButton.tagName === 'INPUT') {
          submitButton.value = saveText
        } else {
          submitButton.textContent = saveText
        }
      }
    }
  }
}

export default ExperienceDateValidationController
